import React from "react";
import { ApiService } from "../../services/api_service";
import { LegalPage, PointParagraph, useLegalDocument } from "../legal/LegalPage";
import "./Termsandcondition.css";

/**
 * Terms & Conditions — mirrors the mobile app's Terms And Conditions screen.
 *
 * All copy comes from `GET /tnc`; nothing is hardcoded here. Page chrome, the
 * fetch behaviour and point rendering are shared with the Privacy Policy page
 * (see ../legal/LegalPage).
 */

const TncItem = ({ item }) => {
  const heading = item.showIndex ? `${item.index}. ${item.mainPoint}` : item.mainPoint;

  return (
    <li className="tnc-item">
      {/* The closing item carries an empty mainPoint — skip the heading entirely. */}
      {heading.trim().length > 0 && <h2 className="legal-section-title">{heading}</h2>}

      <div className="legal-points">
        {item.subPoints.map((sp, i) => (
          <PointParagraph key={i} header={sp.header} point={sp.subPoint} />
        ))}
      </div>
    </li>
  );
};

const TermsAndcondition = () => {
  const { status, data, retry } = useLegalDocument(
    ApiService.getTermsAndConditions,
    "terms and conditions"
  );

  return (
    <LegalPage
      title="Terms And Conditions"
      documentName="terms and conditions"
      status={status}
      onRetry={retry}
    >
      {/* Response order is display order — `index` is text, not a sort key. */}
      {data.map((item) => (
        <TncItem key={item.id} item={item} />
      ))}
    </LegalPage>
  );
};

export default TermsAndcondition;
